import { useEffect } from 'react';
import { useImmerAtom } from 'jotai-immer';
import { cpOrderInvoicesDetailsPageStateAtom } from './cp_order_invoices_details_atoms';
import { ngContext } from '../../../core/services/ng.delegate';
import utilSvc from '../../../core/utilSvc';
import { useFetchInvoice } from './useFetchInvoice';

export const useOrdersCpOrderInvoicesDetailsInit = (): { title: string } => {
    const [state, setState] = useImmerAtom(cpOrderInvoicesDetailsPageStateAtom);
    const fetchInvoice = useFetchInvoice();

    useEffect(() => {
        // Read context imperatively at mount time; capture user data for downstream use
        const ctx = ngContext();
        setState(draft => {
            draft.userType = ctx.User?.Type ?? '';
            draft.userAffList = ctx.User?.AffList ?? [];
            draft.hasTrueUpFeature = utilSvc.user.hasFeature(ctx.User, 'invoice.trueup');
            draft.isVeriSaveOnly = !!ctx.User?.VeriSaveOnly;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (state.id) {
            fetchInvoice(state.id);
        }
    }, [state.id, fetchInvoice]);

    return {
        title: state.title,
    };
};
